import { BankOutlined, BellOutlined, CustomerServiceOutlined, UserOutlined, WalletOutlined } from '@ant-design/icons'
import { Badge, ConfigProvider, Dropdown, Empty, Layout } from 'antd'
import PrivateFooter from 'components/Footer/PrivateFooter'
import ModalPayment from 'components/Modal/ModalPayment'
import { useSocket } from 'hooks/useSocket'
import moment from 'moment'
import RouteList from 'pages/Routes'
import DeletePaymentModal from 'pages/Send/components/DeletePaymentModal'
import SelectPayment from 'pages/Send/components/SelectPayment'
import { useEffect, useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useGetPaymentList } from 'services/swr/payment'
import { useGetMe, useNotification } from 'services/swr/user'

const Header = ({ userId }) => {
  const navigate = useNavigate()
  const { lastMessage } = useSocket(userId)
  const { data: notiList } = useNotification()

  const [dataList, setDataList] = useState<any>([])
  const [hasNewMsg, setHasNewMsg] = useState(0)
  const [isChooseRecipient, setIsChooseRecipient] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState<number | undefined>()

  const toggleChooseRecipient = () => setIsChooseRecipient(prev => !prev)
  const toggleDeleteModal = (id: number | undefined) => setOpenDeleteModal(id)

  useEffect(() => {
    if (!lastMessage?.id) return
    setHasNewMsg((prev) => prev + 1)
    setDataList((prev) => [lastMessage, ...prev])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastMessage?.id])

  useEffect(() => {
    if (!notiList?.length) return
    setDataList(notiList)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notiList?.length])

  return (
    <div className='flex items-center justify-between gap-4 py-3 fixed top-0 left-0 right-0 container bg-white z-10'>
      <NavLink to={RouteList.profile}>
        <div className='rounded-full p-1 bg-primary'>
          <UserOutlined className='text-2xl text-white' />
        </div>
      </NavLink>

      {/* <NavLink to={RouteList.home}>
        <Image preview={false} src='/images/logo/main-logo.svg?v=1.4' className='!w-10' />
      </NavLink> */}

      <div className='flex items-center gap-4'>
        <WalletOutlined className='text-2xl' onClick={() => navigate(RouteList.wallet)} />
        <BankOutlined className='text-2xl' onClick={toggleChooseRecipient} />
        <Dropdown
          menu={{
            items: !dataList?.length
              ? [{ key: 0, label: <Empty /> }]
              : dataList.map((x) => ({
                key: x.id,
                label: <ContentDisplay htmlContent={x.description} />,
              })),
          }}
          trigger={['click']}
        >
          <Badge dot={!!hasNewMsg}>
            <BellOutlined className='text-2xl' onClick={() => setHasNewMsg(0)} />
          </Badge>
        </Dropdown>
        <CustomerServiceOutlined className='text-2xl' />
      </div>

      <SelectPayment onClose={toggleChooseRecipient} open={isChooseRecipient} onDelete={toggleDeleteModal} />
      <DeletePaymentModal open={openDeleteModal} onCancel={() => toggleDeleteModal(undefined)} />
      <ModalPayment />
    </div>
  )
}

const PrivateLayout = ({ children }) => {
  useGetPaymentList()

  const { data: myProfile } = useGetMe({
    refreshInterval: (data) => {
      if (!data?.updated_at) return 3000

      const updatedAt = moment(data.updated_at)
      const now = moment()
      const fiveMinutesLater = updatedAt.clone().add(5, 'minutes').add(10, 'seconds')
      const diff = fiveMinutesLater.diff(now)

      if (now.isBefore(fiveMinutesLater)) return diff
      return (5 * 60 + 10) * 1000
    },
  })

  return (
    <Layout className='public-layout !bg-primary'>
      <ConfigProvider>
        <Header userId={myProfile?.id} />
        <div className='flex-1 bg-white pt-20 pb-24 container'>{children}</div>
        <PrivateFooter />
      </ConfigProvider>
    </Layout>
  )
}

export default PrivateLayout

const ContentDisplay: React.FC<{ htmlContent: string }> = ({ htmlContent }) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: htmlContent }}
      className='max-w-[260px] border-b border-solid border-[#e2e3e5] pb-2'
    />
  )
}
